import React from 'react';

import play from '../../../../assets/icons/play_arrow_white.png';
import lock from '../../../../assets/icons/lock_white.png';
import { buildAnchorCheckoutLink } from '../../../../utils/helpers';


export const LockIcon = ({ isLocked }) => {
  if (!isLocked) {
    return null;
  }

  return (
    <div className="private-video-lock-icon">
      <img alt="Lock" src={lock} />
    </div>
  );
};

export const PlayIcon = () => (
  <div className="private-video-play-icon">
    <img alt="Play" src={play} />
  </div>
);

export const PriceForClipStoreItem = ({ payPerViewNav, price }) => {
  const shouldShowPrice = payPerViewNav === 'New' && price > 0;
  if (!shouldShowPrice) {
    return null;
  }

  return (
    <>
      <div className="private-video-price private-gallery-price">
        ${price}
      </div>
      <div className="private-video-buy-now-cta private-gallery-buy-now-cta">
        Buy Now!
      </div>
    </>
  );
};

export const linkToPaymentPage = (isSubscribed, anchorId, anchorShortUrl) => {
  if (isSubscribed) {
    return '#';
  }

  return buildAnchorCheckoutLink(anchorId, anchorShortUrl);
};


